<template>
  <section class="task-wrap" :style="dBHeight">
    <DashBoardHeader ref="dashboardHeader" />
    <div class="tab_ty1" v-if="!noData">
      <ul class="tab-menu">
        <li
          v-for="(tab, index) in tabs"
          v-bind:class="{ active: currentTab === index }"
          :key="'tab_' + index"
        >
          <button type="button" @click="changeTab(index)">
            <!-- v-on:click="currentTab = index" -->
            {{ tab }}
          </button>
        </li>
      </ul>
      <div class="tab-content">
        <!-- 업무리스트 Tab -->
        <div class="tab_ty2" v-show="currentTab == 0">
          <ul class="tab-menu">
            <li
              v-for="(tab, index) in tabs2"
              v-bind:class="{ active: currentTab2 === index }"
              :key="'tabs2_' + index"
            >
              <button type="button" @click="changeTab2(index)">
                {{ tab }}
              </button>
            </li>
          </ul>
          <div class="tab-content">
            <!-- 업무리스트 Tab -->
            <!-- 전체 -->
            <DashbarodAllList 
              v-show="allListYn && currentTab2 == 0" 
              ref="dashboardAllList"
              :publicYn="publicYn"
              :loginUserIsInternalUser="loginUserIsInternalUser"
              v-on:folderLength="folderLength"
            />
            <!-- 리스트 -->
            <DashboardList
              v-show="allListYn ? currentTab2 == 1 : currentTab2 == 0"
              ref="dashboardList"
              v-on:add-category="addcategory"
              v-on:delete-category="deleteCategory"
              v-on:update-categoryName="updateCategoryName"
              v-on:folderLength="folderLength"
              :projectName="projectName"
              :publicYn="publicYn"
              :loginUserIsInternalUser="loginUserIsInternalUser"
            />
            <!-- 칸반 -->
            <div v-show="allListYn ? currentTab2 == 2 : currentTab2 == 1">
              <!-- style="text-align: -webkit-center; margin: 20px" -->
              <DashboardKanban
                ref="dashboardkanban"
                :loginUserId="loginUserId"
              />
            </div>
            <!-- 히스토리 -->
            <div v-show="allListYn ? currentTab2 == 3 : currentTab2 == 2">
              <DashboardHistory
                ref="dashboardHistory"
                :loginUserIsInternalUser="loginUserIsInternalUser"
              />
            </div>
          </div>
        </div>
        <!-- 파일모아보기 Tab -->
        <div v-show="currentTab == 1">
          <div class="tab_ty2">
            <ul class="tab-menu">
              <li
                v-for="(tab, index) in tabs3"
                v-bind:class="{ active: currentTab3 === index }"
                :key="index"
              >
                <button type="button" @click="changeTab2(index)">
                  {{ tab }}
                </button>
              </li>
            </ul>
            <div class="tab-content">
              <div v-show="currentTab3 == 0">
                <ProjectFileList ref="projectFileList" />
              </div>
              <div v-show="currentTab3 == 1">
                <BoardFileList
                  ref="boardFileList"
                  @update-categoryName="updateCategoryName"
                  @deleteCategoryAtFile="deleteCategoryAtFile"
                />
              </div>
            </div>
          </div>

          <!-- <TaskWrap2 v-show="currentTab == 0"/> -->
          <!-- <TaskWrap3 v-show="currentTab == 1"/> -->
        </div>
      </div>
    </div>
    <!-- noData 생성 화면  -->
    <div class="task-cnt krs001" v-if="noData">
      <div class="inner">
        <div class="step-box">
          <div class="step1" :class="step1 ? 'disabled' : ''">
            <div class="tit">STEP 1</div>
            <div class="box">
              <div class="txt">
                {{$i18nUtil.trans("message.Dashboard.011","과제 공간이 생성되었습니다.")}}
                <br />
                {{$i18nUtil.trans("message.Dashboard.012","과제에서 수행 중인 과정을 먼저 등록해주세요.")}}
              </div>
              <div class="txt" v-html="$i18nUtil.trans('message.Dashboard.013','과정명은 리서치, 기획 등 업무 프로세스 별로 구분하거나,<br /> 공지사항, 주간 보고와 같이 업무 구분 형태로 자유롭게 생성하여 사용할 수 있습니다.')"></div>
              <form action="" @submit.prevent="false == false">
                <div class="input-box">
                  <input
                    type="text"
                    required
                    :placeholder='$i18nUtil.trans("entity.category.depth2","과정")'
                    :disabled="step1"
                    v-model="addCategoryName"
                    @input="displayBytes(maxBytes, addCategoryName, $event)"
                    @keyup.enter="nodataAddCategory"
                    @focus="focusTextBox"
                  />
                  <button
                    type="reset"
                    class="input-txt-del"
                    @click="
                      (addCategoryName = ''),
                        (error = false),
                        (checkBytes = 0),
                        (errorCategoryName = true)
                    "
                  >
                    입력 삭제
                  </button>
                  <div class="error" v-if="error">
                    {{ $i18nUtil.trans("message.Dashboard.001","입력 가능한 글자수를 초과하였습니다.") }}
                    <span>({{ checkBytes + `/` + maxBytes + `bytes` }})</span>
                  </div>
                  <div class="error" v-if="errorCategoryName">
                    {{ $i18nUtil.trans("UB006") }}
                  </div>
                </div>
                <button
                  type="button"
                  class="btn-primary-small black"
                  @click="nodataAddCategory"
                  :disabled="!loginUserIsInternalUser"
                >
                  {{ $i18nUtil.trans("button.register","등록") }}
                </button>
              </form>
            </div>
          </div>
          <div class="step2" :class="step2 ? 'disabled' : ''">
            <div class="tit">STEP 2</div>
            <div class="box">
              <div class="txt">{{$i18nUtil.trans("message.Dashboard.003","과정을 완수할 수 있도록 업무 보드를 만들어 보세요.")}}</div>
              <div class="txt">
                {{ $i18nUtil.trans("message.Dashboard.004","과제의 멤버를 구성하면 멤버들과 협업을 통해 업무를 완성할 수 있습니다.") }}
              </div>
              <button
                type="button"
                class="btn-primary-small black"
                @click="nodataAddboard"
              >
                {{ $i18nUtil.trans("button.paper.pro.add","과제 보드 추가") }}
              </button>
            </div>
          </div>
          <!-- <div class="step3 disabled">
                    <div class="tit">STEP 3</div>
                    <div class="box">
                        <div class="txt">{{$i18nUtil.trans("message.Dashboard.014","이제 보드를 만들어 볼까요?")}}</div>
                        <button type="button" class="btn-primary-small black">보드 추가</button>
                    </div>
                </div> -->
        </div>
      </div>
    </div>
    <modals-container
      @registBoard="registBoard"
      @returnOrgParams="registMember"
      @dialogConfirm="dialogConfirm"
      @closeOkrLinkPopup="closeOkrLinkPopup"
      @closeOtherProjectBoardLink="closeOtherProjectBoardLink"
      @update-categoryName="updateCategoryName"
      @add-category="addcategory"
      @delete-category="deleteCategory"
    ></modals-container>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import "../../../../../assets/css/dashboard.css";
//noti socket
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import DashBoardHeader from "./DashBoardHeader";
import DashboardList from "./tab/list/DashboardList";
import DashboardKanban from "./tab/kanban/DashboardKanban";
import DashboardHistory from "./tab/history/DashboardHistory";
import DashbarodAllList from "./tab/allList/DashboardAllList";
/* 2020.09.14 / 김철환 / 파일 모아보기 전체 */
import ProjectFileList from "./tab/file/ProjectFileList";
/* 2020.09.14 / 김철환 / 파일 모아보기 보드별 */
import BoardFileList from "./tab/file/BoardFileList";
/* 이벤트 버스  */
import EventBus from "@/js/eventbus/eventBus";

import axios from "axios";
//보드 추가 모달
import RegistBoardModal from "@/components/cowork/general/board/modal/RegistBoardModal";

/* 캘린더 */
import MAS_Cal from "@/components/cowork/general/calendar/modal/MAS_Cal";

export default {
  name: "tabs",
  components: {
    DashBoardHeader,
    DashboardKanban,
    ProjectFileList,
    BoardFileList,
    DashboardHistory,
    DashboardList,
    DashbarodAllList,
  },
  data() {
    return {
      loginUserIsInternalUser: true,
      /* 진입시 사이트 생성여부확인 카운트 */
      siteCheck: 0,
      noData: false,
      step1: false,
      step2: true,
      addCategoryName: "",
      error: false,
      errorCategoryName: false,
      checkBytes: 0,
      maxBytes: 80,
      parentCategoryMid: null,
      categoryInfo: null,

      userId: "",
      userInfo: null,
      currentTab: 0,
      currentTab2: 0,
      currentTab3: 0,
      tabs: [ this.$i18nUtil.trans("title.Dashboard.tab.001","업무 리스트") , this.$i18nUtil.trans("title.Dashboard.tab.002","파일 모아보기") ],
      tabs2: [],
      tabs3: [ this.$i18nUtil.trans("title.Dashboard.tab.002.allFile","전체") , this.$i18nUtil.trans("title.Dashboard.tab.002.boardFile","보드별") ],
      dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
      },
      res: {},
      projectId: "",
      projectName: "",
      groupId: "",
      publicYn: "",
      loginUserId: "",
      countUser: null,
      //noti
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      prevBtn: false,
      prevState: [],

      allListYn:false,

      /* timeInterval 정보, 후처리를 위해 사용 */
      reconnectionFunc: null,
      tenantId: localStorage.getItem("tenantId"),
    };
  },
  computed: {
    ...mapState("project", ["projectInfo"]),
    ...mapState("project", ["projectMemberList"]),
    ...mapState("project", ["projectMemberCount"]),
    ...mapState("project", ["projectOkrLinkList"]),
  },
  async created() {
    let localStorageAllListYn  = localStorage.getItem("boardAllListUse");
    if(localStorageAllListYn === "true"){
      this.allListYn = true;
      this.tabs2 = [
        this.$i18nUtil.trans("title.Dashboard.tab.001.DashbarodAllList","전체"), 
        this.$i18nUtil.trans("title.DashboardList.001","과정별"), 
        this.tenantId == '201' ? this.$i18nUtil.trans("title.Dashboard.tab.001.DashboardProcess","진행현황") : this.$i18nUtil.trans("title.Dashboard.tab.001.DashboardKanban","칸반"),
        this.$i18nUtil.trans("title.Dashboard.tab.001.DashboardHistory","히스토리")
      ];
    }else{
      this.tabs2 = [
        this.$i18nUtil.trans("title.Dashboard.tab.001.DashboardList","리스트"), 
        this.tenantId == '201' ? this.$i18nUtil.trans("title.Dashboard.tab.001.DashboardProcess","진행현황") : this.$i18nUtil.trans("title.Dashboard.tab.001.DashboardKanban","칸반"),
        this.$i18nUtil.trans("title.Dashboard.tab.001.DashboardHistory","히스토리")
      ];
      this.allListYn = false;
    }
    
    // [2024-01-30] 손해보험 일정 추가
    if (this.tenantId == '201') {
      this.tabs2.push(this.$i18nUtil.trans("title.Dashboard.tab.001.Calendar","일정"));
    }

    this.projectId = await this.$route.params.projectId;
    this.showLoadingbar();
    this.setProjectInfo(this.projectId);
  },
  beforeDestroy() {
    if (window.sessionStorage.length != 0) {
      if (window.sessionStorage.getItem("moveBoard") === "true") {
        // 보드로 이동 시에는 sessionStorage를 지우지 않음.
      } else {
        window.sessionStorage.clear();
      }
    }
    /* 후처리 (소캣 재접속 스레드 클리어) */
    try { clearInterval(this.reconnectionFunc); } catch (ignore) { }
    try { this.stompClient.disconnect(() => {}); } catch (ignore) { }
    try { this.socket.close(); } catch (ignore) { }
  },
  mounted() {
    /* 후처리가 되지 않은경우 마저 클리어 */
    if (this.reconnectionFunc) {
      clearInterval(this.reconnectionFunc);
    }
    this.connectByProjectId();
    let currentTab2Idx = this.allListYn ? 1 : 0;
    EventBus.$off("goProjectListTab");
    EventBus.$on("goProjectListTab", (payload) => {
      this.currentTab = 0;
      this.changeTab2(currentTab2Idx, payload);
    });

    // 뒤로가기 이벤트 발생시 .
    const self = this;
    window.onpopstate = function (event) {
      if (window.sessionStorage.getItem("dashboard") != null) {
        let sessionState = JSON.parse(
          window.sessionStorage.getItem("dashboard")
        );
        if (sessionState.length != 0) {
          let currnetTabInfo = sessionState.pop();
          if (window.sessionStorage.getItem("moveBoard") === "true") {
            // setProjectInfo(this.projectId);
            sessionState.push(currnetTabInfo);
            window.sessionStorage.setItem(
              "dashboard",
              JSON.stringify(sessionState)
            );
          }
          // 같은 TAB에서 뒤로가기 눌렸을시.
          else if (
            currnetTabInfo.currentTab == self.currentTab &&
            currnetTabInfo.currentTab == self.currentTab &&
            currnetTabInfo.currentTab == self.currentTab
          ) {
            if (sessionState.length == 0) {
              // window.sessionStorage.setItem("dashboard", JSON.stringify(sessionState));
              window.sessionStorage.removeItem("dashboard");
              window.sessionStorage.removeItem("moveBoard");
              window.sessionStorage.removeItem("prevBtn");
              self.goPrevPage();
            } else {
              let prevTabInfo = sessionState.pop();
              self.prevState = prevTabInfo;

              window.sessionStorage.setItem(
                "dashboard",
                JSON.stringify(sessionState)
              );
              self.currentTab = prevTabInfo.currentTab;
              self.currentTab2 = prevTabInfo.currentTab2;
              self.currentTab3 = prevTabInfo.currentTab3;
              self.prevBtn = true;
              if (self.currentTab == 0) {
                self.changeTab2(self.currentTab2);
              } else {
                self.changeTab2(self.currentTab3);
              }
            }
          }
        } else {
        }
      }
    };
  },
  watch: {
    projectMemberList() {
      let obj = this;
      this.projectMemberList.forEach(function (user) {
        if (user.userId == obj.userId) {
          obj.userInfo = user;
        }
      });
    },
    countUser() {
      this.$refs.dashboardHeader.setProjectId(this.res);
    },
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("restAction", ["ASYNC_COWORK_REST_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapMutations("project", ["setProjectOkrLinkList"]),
    ...mapMutations("project", ["setProjectMemberList"]),
    ...mapMutations("project", ["setProjectMemberCount"]),
    ...mapMutations("project", ["setProjectInvitationMemberList"]),
    ...mapMutations("project", ["setProjectInvitationMemberCount"]),
    ...mapActions("modals", ["showModal", "showToast"]),
    ...mapActions("noti", ["setEventBackYn"]),
    //GNB 알림 set
    //...mapActions("noti", ["setNotiInfo"]),
    //...mapActions("dashboard", ["setDashBoard"]),
    setProjectInfo(projectId) {
      this.projectId = projectId;
      let obj = this;
      let reqData = {};
      reqData.params = {
        projectId: projectId,
      };
      reqData.req = obj.req;
      reqData.url = "/api/cogroup/project/getProjectInfo";
      reqData.method = "post";

      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode == "NOT_AUTHORIZED") {
            obj.$router.push("/general/project");
            obj.hideLoadingbar();
          } else if (res.errorCode == "SITE_CREATING") {
            obj.siteCheck = obj.siteCheck + 1;

            if (obj.siteCheck > 3) {
              obj.toastInfo.message =
                this.$i18nUtil.trans("message.Dashboard.005","과제 공간을 생성 중입니다. 잠시 후 다시 시도해주세요.");
              obj.showToast(obj.toastInfo);
              obj.$router.replace("/general/project");
              obj.hideLoadingbar();
            } else {
              setTimeout(() => {
                obj.setProjectInfo(this.projectId);
              }, 1000);
            }
          } else if (res.errorCode == "SITE_ERROR") {
            obj.toastInfo.message = obj.$i18nUtil.trans("message.Dashboard.006","사이트 생성 중 오류 발생");
            obj.showToast(obj.toastInfo);
            obj.$router.replace("/general/project");
            obj.hideLoadingbar();
          } else {
            if (res.result.project.delDate != null) {
              obj.showAlertDialog(
                obj.$i18nUtil.trans("TB079"),
                obj.$i18nUtil.trans("title.dialog.notice","알림"),
                { width: "400px" },
                obj.$i18nUtil.trans("button.dialog.confirm","확인"),
                obj.closureAlertConfirm
              );
            } else {
              this.loginUserIsInternalUser = res.result.loginUserIsInternalUser;
              this.res = res;
              this.groupId = res.result.project.groupId;
              this.$refs.dashboardHeader.setProjectId(this.res);
              this.projectName = res.result.project.projectName;
              this.publicYn = res.result.cogroup.publicYn;
              //this.projectInfo = res.result.project;
              this.userId = res.result.loginUserId;
              //리스트 데이터 세팅
              // this.changeTab2(0);
              if (window.sessionStorage.getItem("moveBoard") === "true") {
                let sessionState = JSON.parse(
                  window.sessionStorage.getItem("dashboard")
                );
                let currentState = sessionState[sessionState.length - 1];
                this.currentTab = currentState.currentTab;
                this.currentTab2 = currentState.currentTab2;
                this.currentTab3 = currentState.currentTab3;
              }
              this.changeTab2(this.currentTab2);
              // this.$refs.dashboardList.setprojectIdAndGroupId(
              //   this.projectId,
              //   this.groupId,
              //   this.userId
              // );

              // 과제 LAST_ACCESS_DAY 갱신
              this.updateAccessDay();
            }

            obj.hideLoadingbar();
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    updateAccessDay(){
      let obj = this;
      let reqData = {};
      reqData.params = {
        groupId:this.groupId
      };
      reqData.req = obj.req;
      reqData.url = "/api/cogroup/cogroup/updateLastAccessDay";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => { })
        .catch(function (err) { console.log(err); });
    },
    closureAlertConfirm() {
      this.$router.replace("/general/project");
    },
    addcategory(param, parentCategory) {
      let obj = this;
      let reqData = {};
      reqData.params = param;
      reqData.req = obj.req;
      reqData.url = "/api/copaper/category/saveCategory";
      reqData.method = "post";
      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          //this.setDashBoard(this.projectId);
          if (res.errorCode != null) {
            if (res.errorCode == "DUPLICATE_CATEGORY_NAME") {
              obj.toastInfo.message = obj.$i18nUtil.trans("UB024");
              obj.showToast(obj.toastInfo);
              return;
            }
          } else {
            this.$refs.dashboardList.setprojectIdAndGroupId(
              this.projectId,
              this.groupId,
              this.userId
            );
            obj.toastInfo.message = obj.$i18nUtil.trans("TB022");
            obj.showToast(obj.toastInfo);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    deleteCategory(param, parentCategory) {
      if (this.userInfo == null) {
        // 멤버가 아님 .
        this.showAlertDialog(this.$i18nUtil.trans("TB053"), null, {
          width: "400px",
          // height: "148px",
        });
        return;
      } else if (
        this.userInfo != null &&
        this.userInfo.userGrade == "MANAGER"
      ) {
        param.item.category.delKbn = 1;
        let deleteFolderList = [];
        deleteFolderList.push(param.item.category);
        let obj = this;
        let reqData = {};
        reqData.params = {
          deleteFolderList: deleteFolderList,
        };
        reqData.req = obj.req;
        reqData.url = "/api/copaper/category/deleteCategoryList";
        reqData.method = "post";
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then((res) => {
            if (res.errorCode != null) {
              if (res.errorCode == "DELETE_FOLDER_NOT_AVAILABLE") {
                obj.toastInfo.message = obj.$i18nUtil.trans("AB032");
                obj.showToast(obj.toastInfo);
                return;
              }
              console.log(res);
            } else {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB024");
              obj.showToast(obj.toastInfo);
            }
          })
          .catch(function (err) {
            console.log(err);
          });
      } 
      // else if (
      //   param.item.paperCount != 0 &&
      //   this.userInfo.userGrade != "MANAGER"
      // ) 
      // {
      //   //운영자가 아니고 하위에 보드가 존재
      //   this.showAlertDialog(this.$i18nUtil.trans("AB031"), null, {
      //     width: "400px",
      //     // height: "148px",
      //   });
      //   return;
      // } 
      else {
        param.item.category.delKbn = 1;
        let deleteFolderList = [];
        deleteFolderList.push(param.item.category);
        let obj = this;
        let reqData = {};
        reqData.params = param.item.category;
        reqData.req = obj.req;
        reqData.url = "/api/copaper/category/saveCategory";
        reqData.method = "post";
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then((res) => {
            if (res.errorCode != null) {
              console.log(res);
            } else {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB024");
              obj.showToast(obj.toastInfo);
            }
          })
          .catch(function (err) {
            console.log(err);
          });
      }
    },
    resetviewStyle() {
      this.changedashboard = "none";
    },
    updateCategoryName(item) {
      let obj = this;
      let reqData = {};
      reqData.params = {
        projectId: item.category.projectId,
        categoryMid: item.category.categoryMid,
        newCategoryName: item.category.categoryName,
      };

      reqData.req = obj.req;
      reqData.url = "/api/copaper/category/updateCategoryName";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode != null) {
            if (res.errorCode == "DUPLICATE_CATEGORY_NAME") {
              obj.toastInfo.message = obj.$i18nUtil.trans("UB024");
              obj.showToast(obj.toastInfo);
              return;
            }
          } else {
            obj.toastInfo.message = obj.$i18nUtil.trans("TB023");
            obj.showToast(obj.toastInfo);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    dialogConfirm(modalData) {
      let obj = this;
      if (!modalData.dialogType) {
        return;
      }
      if (modalData.dialogType == "PROJECT_CLOSURE") {
        let obj = this;
        let reqData = {
          url: "/api/cogroup/project/updateProjectClosure",
          method: "post",
          req: {
            projectId: this.projectId,
            groupId: this.groupId,
          },
        };

        obj
          .COWORK_REST_ACTION(reqData)
          .then((data) => {
            let body = document.querySelector("body");
            body.style.removeProperty("overflow");
            obj.toastInfo.message = obj.$i18nUtil.trans("TB079");
            obj.showToast(obj.toastInfo);
            obj.$router.replace("/general/project");
          })
          .catch((err) => {
            console.log(err);
            console.log("[폐쇄 오류]");
          });
      } else if (modalData.dialogType == "ADD_MEMBER") {
        let addJson = {};
        let addCogroupUserList = [];
        if (modalData.data !== null && modalData.data !== undefined) {
          addJson.userId = modalData.data.userId;
          addJson.userKbn = "01";
          addJson.userGrade = "MEMBER";
          addCogroupUserList.push(addJson);
        }
        let reqData = {};
        reqData.req = {
          groupId: obj.groupId,
          addCogroupUserList: addCogroupUserList,
        };
        reqData.url = "/api/cogroup/cogroupUser/registCogroupUser";
        reqData.method = "post";
        this.loader = this.$loading.show();
        obj
          .COWORK_REST_ACTION(reqData)
          .then((res) => {
            if (res.errorCode) {
              console.log(res.errorCode);
            } else {
              if(res.result.checkPolicy && res.result.checkPolicy.length >0 ){
                let checkPolicy = "";
                res.result.checkPolicy.forEach((res)=>{
                  checkPolicy += ("- " + res.chineseWallPolicyName + "\n");
                })
                obj.showAlertDialog(obj.$i18nUtil.trans("AB112",{ checkPolicy: checkPolicy}));
                obj.loader.hide();
                return;
              }

              if (res.result.blockUser.length > 0) {
                this.toastInfo.message =
                  this.$i18nUtil.trans("message.Dashboard.007","정보교류차단 지침에 따라 멤버 초대가 불가능한 사용자입니다.");
                this.showToast(this.toastInfo);
              } else {
                obj.setProjectMemberList(res.result.data);
                obj.setProjectMemberCount(res.result.countuser);
                this.toastInfo.message = obj.$i18nUtil.trans("TB064");
                this.showToast(this.toastInfo);
              }

              obj.loader.hide();
            }
          })
          .catch((err) => {
            console.log("axios err => ", err);
          });
      } else if (modalData.dialogType == "INVITATION") {
        const reqData = {
          url: "/api/cogroup/cogroupUser/setUserInvitation",
          method: "post",
          obj: obj,
          req: {
            invitationMemberList: modalData.invitationMemberList,
            groupId: obj.groupId,
          },
        };
        obj
          .COWORK_REST_ACTION(reqData)
          .then((res) => {
            obj.setProjectInvitationMemberList(res.result.userManage);
            obj.setProjectMemberList(res.result.user);
            obj.setProjectMemberCount(res.result.user.length);
            obj.setProjectInvitationMemberCount(res.result.count);
            obj.toastInfo.message = obj.$i18nUtil.trans("TB063", {
              countInviteMember: modalData.inviteCount,
            });
            obj.showToast(obj.toastInfo);
            const responseUsers = res.result.responseUsers;
            const url = window.location.href.split("/");
            const hostUrl = url[0] + "/" + url[1] + "/" + url[2];
            for (let i = 0; i < responseUsers.length; i++) {
              if (responseUsers[i].isUser) {
                console.log(
                  "[" + responseUsers[i].email + "] : 이미 가입중인 멤버"
                );
              } else {
                console.log(
                  "[" +
                    responseUsers[i].email +
                    "] : " +
                    hostUrl +
                    "/join?eParam=" +
                    responseUsers[i].encryptEmail +
                    "&pParam=" +
                    responseUsers[i].encryptProjectId
                );
              }
            }
            EventBus.$emit("invitationPopupClose");
          })
          .catch((err) => {
            console.log(err);
            console.log("[초대 오류]");
          });
      } else if (modalData.dialogType == "REQUEST_REJECT") {
        const reqData = {
          url: "/api/cogroup/cogroupUserManage/deleteCogroupUserManage",
          method: "post",
          obj: obj,
          req: {
            groupId: obj.groupId,
            userMngMid: modalData.data,
            joinYn: "Y",
          },
        };
        obj
          .COWORK_REST_ACTION(reqData)
          .then((res) => {
            if (res.errorCode) {
              console.log(res.errorCode);
            } else {
              EventBus.$emit("invitationRequestMemberList", res.result.data);
              obj.toastInfo.message = obj.$i18nUtil.trans("TB069");
              obj.showToast(obj.toastInfo);
            }
          })
          .catch((err) => {
            console.log(err);
            console.log("[가입요청 거절 오류]");
          });
      } else {
        let deleteUserList = [];
        let reqData = {};
        if (modalData.dialogType == "SELF_REJECT") {
          // if (modalData.deleteUserList[0].userGrade == "MANAGER") {
          //   let managerYn = 0;
          //   for (let i = 0; i < this.projectMemberList.length; i++) {
          //     if (this.projectMemberList[i].userGrade == "MANAGER") {
          //       managerYn++;
          //     }
          //   }
          //   if (managerYn == 1) {
          //     const modalInfo = {
          //       title: "알림",
          //       width: "400px",
          //       height: "166px",
          //       obj: this.$modal,
          //       contents: "운영자는 한명 이상 존재해야 합니다.",
          //       button: "확인",
          //       component: Dialog,
          //     };
          //     this.showModal(modalInfo);
          //     return;
          //   }
          // }
          reqData = {
            url: "/api/cogroup/cogroupUser/deleteCogroupUser",
            method: "post",
            req: {
              groupId: obj.groupId,
              userGrade: modalData.deleteUserList[0].userGrade,
            },
          };
        } else {
          let deleteUserCount = 0;
          let projectManagerCount = 0;
          this.projectMemberList.forEach((value) => {
            if (value.userGrade == "MANAGER") {
              projectManagerCount += 1;
            }
          });
          modalData.deleteUserList.forEach((value) => {
            if (value.userGrade == "MANAGER") {
              deleteUserCount += 1;
            }
          });
          if (deleteUserCount == projectManagerCount) {
            const modalInfo = {
              title: this.$i18nUtil.trans("title.dialog.notice","알림"),
              width: "400px",
              // height: "166px",
              obj: this.$modal,
              contents: this.$i18nUtil.trans("AB064"),
              button: this.$i18nUtil.trans("button.dialog.confirm","확인"),
              component: Dialog,
            };
            this.showModal(modalInfo);
            return;
          }
          reqData = {
            url: "/api/cogroup/cogroupUser/deleteCogroupUser",
            method: "post",
            req: {
              groupId: obj.groupId,
              deleteCogroupUserList: modalData.deleteUserList,
            },
          };
        }
        this.loader = this.$loading.show();
        obj
          .COWORK_REST_ACTION(reqData)
          .then((res) => {
            obj.setProjectMemberList(res.result.data);
            obj.setProjectMemberCount(res.result.countuser);
            obj.loader.hide();
            if (modalData.dialogType == "SELF_REJECT") {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB025", {
                targetName: this.$i18nUtil.trans("entity.project","과제"), // obj.projectName,
              });
            } else {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB028", {
                userName: modalData.userName,
                countMember: modalData.deleteUserList.length - 1,
              });
            }

            obj.showToast(obj.toastInfo);
            EventBus.$emit("updateCogroupUser");
            if (res.result.isSharePaper) {
              obj.$router.replace("/general/cooperationMemberBoard");
            } else {
              if (modalData.dialogType == "SELF_REJECT" && obj.publicYn == 0) {
                obj.$router.replace("/general/project");
              }
            }
          })
          .catch((err) => {
            console.log(err);
            console.log("[멤버탈퇴오류]");
          });
      }
    },
    registMember(data) {
      let obj = this;
      let type = data.orgType;
      let depts = data.depts;
      let users = data.users;

      if (depts.length > 0 || users.length > 0) {
        if (users.length > 0) {
          if (data.modalObj.modalInfo.memberType == "INVITATION") {
            //멤버 초대에서 조직도 확인시
            // let addUserList = [];
            // users.forEach(function (item, index, arr) {
            //   //console.log("item:", item);
            //   let jsonData = {};
            //   jsonData.userId = item.userId;
            //   jsonData.userName = item.userName;
            //   addUserList.push(jsonData);
            // });
            // const reqData = {
            //   url: "/api/cogroup/orgUser/getEmailByUserId",
            //   method: "post",
            //   obj: obj,
            //   req: {
            //     addUserList: addUserList,
            //   },
            // };
            // this.loader = this.$loading.show();
            // obj
            //   .COWORK_REST_ACTION(reqData)
            //   .then((res) => {
            //     if (res.errorCode) {
            //       console.log(res.errorCode);
            //     } else {
            //       EventBus.$emit("addInvitationMember", res.result);
            //     }
            //     obj.loader.hide();
            //   })
            //   .catch((err) => {
            //     console.log(err);
            //   });
          } else {
            //멤버 추가에서 조직도 확인시
            let alreadyMember = 0;
            let addMember = 0;
            let addUserList = [];
            users.forEach(function (item, index, arr) {
              let isMember = false;
              obj.projectMemberList.forEach((value) => {
                if (value.userId == item.userId) {
                  isMember = true;
                }
              });
              let jsonData = {};
              if (isMember) {
                alreadyMember++;
              } else {
                addMember++;
                jsonData.groupId = obj.groupId;
                jsonData.userId = item.userId;
                jsonData.userGrade = "MEMBER";
                jsonData.userKbn = "01";
                addUserList.push(jsonData);
              }
            });

            const reqData = {
              url: "/api/cogroup/cogroupUser/registCogroupUser",
              method: "post",
              obj: obj,
              req: {
                groupId: obj.groupId,
                addCogroupUserList: addUserList,
              },
            };
            this.loader = this.$loading.show();
            obj
              .COWORK_REST_ACTION(reqData)
              .then((res) => {
                if (res.errorCode) {
                  console.log(res.errorCode);
                } else {
                  if(res.result.checkPolicy && res.result.checkPolicy.length >0 ){
                    let checkPolicy = "";
                    res.result.checkPolicy.forEach((res)=>{
                      checkPolicy += ("- " + res.chineseWallPolicyName + "\n");
                    })
                    obj.showAlertDialog(obj.$i18nUtil.trans("AB112",{ checkPolicy: checkPolicy}));
                    obj.loader.hide();
                    return;
                  }

                  if (addMember == 0) {
                    obj.toastInfo.message = obj.$i18nUtil.trans("message.Dashboard.009","이미 등록된 멤버입니다.");
                  } else {
                    if (res.result.blockUser.length > 0) {
                      let userListStr = "";
                      res.result.blockUser.forEach((element, index, array) => {
                        userListStr += element.userName;
                        if (index != array.length - 1) {
                          userListStr += ",";
                        }
                      });
                      obj.toastInfo.message =
                        obj.$i18nUtil.trans("message.Dashboard.010","{user}은(는) 정보교류차단 지침에 따라 멤버 초대가 불가능한 사용자입니다.", {user: userListStr});
                      obj.showToast(this.toastInfo);
                    } else {
                      obj.toastInfo.message = obj.$i18nUtil.trans("TB064");
                      obj.showToast(obj.toastInfo);
                    }
                  }
                  this.$refs.dashboardHeader.setProjectId(this.res);
                  obj.setProjectMemberList(res.result.data);
                  obj.setProjectMemberCount(res.result.countuser);
                  EventBus.$emit("updateCogroupUser");
                  obj.loader.hide();
                }
              })
              .catch((err) => {
                console.log(err);
                console.log("[멤버추가 오류]");
                alert("[멤버추가 오류]");
              });
          }
        }
      }
    },
    registBoard(_data) {
      let obj = this;
      let reqData = {};
      reqData.params = {
        paperTitle: _data.paperTitle,
        paperId: _data.paperId,
        groupId: _data.groupId,
        categoryMid: _data.categoryMid,
        contentPath: _data.contentPath,
        docGrade: _data.docGrade,
        blockType: "CONTENT",
        link: "/general/board/" + _data.paperId,
        tagList: _data.tagList
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/paper/addPaper";
      reqData.method = "post";
      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode != null) {
            console.log(res.errorCode);

            return;
          }
          this.toastInfo.message = this.$i18nUtil.trans("TB036");
          this.showToast(this.toastInfo);
          //this.showToast(this.toastInfo);
          let path = "/general/board/" + res.result;
          this.$router.push(path);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    connectByProjectId() {
      const serverUrl = "/api/copaper/websocket";
      this.socket = new SockJS(serverUrl, null, {transports: ["websocket"]});
      this.socket.protocol = 'v12.stomp';
      this.stompClient = Stomp.over(this.socket);
      this.stompClient.heartbeat.outgoing = 20000;
      this.stompClient.heartbeat.incoming = 0;
      this.stompClient.reconnect_delay = 5000;
      this.stompClient.debug = (msg) => {
        //console.log("SOCK:", msg);
      };      
      this.stompClient.connect(
        {
          Authorization: localStorage.getItem("Authorization"),
        },
        (frame) => {
          this.connected = true;
          this.subscribeByProjectId();
          if (this.reconnectionFunc != null) {
            clearInterval(this.reconnectionFunc);
            this.reconnectionFunc = null;
          }
          let sClient = this.stompClient;

          this.reconnectionFunc = setInterval(() => {
            let isConnectedFlag = sClient.connected; 
            if (isConnectedFlag === false) {
              try { this.stompClient.disconnect(() => {}); } catch (ignore) { }
              try { this.socket.close(); } catch (ignore) { }
              this.connectByProjectId();
            }
          }, 5000);
        },
        (error) => {
          console.log(error);
          this.connected = false; 
          setTimeout(location.reload, 1000);
        }
      );
    },
    subscribeByProjectId() {
      this.stompClient.subscribe(
        "/api/copaper/topic/project/subscribe/" + this.$route.params.projectId,
        (message) => {
          let resData = JSON.parse(message.body);
          let currentTab2Idx = this.allListYn ? 1 : 0;
          if (this.currentTab == 0) {
            if(this.allListYn && this.currentTab2 == 0){
            }
            else if (this.currentTab2 == currentTab2Idx) {
              if(this.$refs.dashboardList != null){
                this.$refs.dashboardList.setprojectIdAndGroupId(
                  this.projectId,
                  this.groupId,
                  this.userId
                );
              }
            } else if (this.currentTab2 == (currentTab2Idx + 1)) {
            } else if (this.currentTab2 == (currentTab2Idx + 2)) {
              if(this.$refs.dashboardHistory != null){
                this.$refs.dashboardHistory.setGroupId(
                  this.groupId,
                  this.projectId,
                  this.userId,
                  this.parentCategoryMid,
                  this.projectName
                );
              }
            } else {
            }
          } else {
          }
        }
      );
    },
    changeTab(index) {
      this.currentTab = index;
      if (index === 0) {
        this.changeTab2(0);
      } else {
        this.changeTab2(0);
      }
    },
    changeTab2(index, payload) {
      //sessionStorage // history 저장.
      if (this.currentTab === 0) {
        this.currentTab2 = index;
      } else {
        this.currentTab3 = index;
      }

      let state = {
        currentTab: this.currentTab,
        currentTab2: this.currentTab2,
        currentTab3: this.currentTab3, 
      };
      if (this.prevBtn) {
        //뒤로가기로 접근.
        let stateArr =
          JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
        state = this.prevState;
        window.sessionStorage.setItem("prevBtn", this.prevBtn);
        if (stateArr.length != 0) {
          history.pushState(state, document.title, location.href);
        }
        this.prevBtn = false;
      } else {
        let stateArr = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
        let lastState = [];
        if (stateArr.length != 0) {
          lastState = stateArr[stateArr.length - 1];
          if (
            lastState.currentTab != this.currentTab ||
            lastState.currentTab2 != this.currentTab2 ||
            lastState.currentTab3 != this.currentTab3
          ) {
            // state = lastState;
            history.pushState(state, document.title, location.href);
          }
        }
      }

      
      if (this.currentTab === 0) {
        let currentTab2Idx = this.allListYn ? 1 : 0;

        // this.currentTab2 = index;
        if(this.allListYn && index === 0){
          // 전체
          this.$refs.dashboardAllList.setInitItem(state);
        } else if (index === currentTab2Idx) {
          this.$refs.dashboardList.setprojectIdAndGroupId(
            this.projectId,
            this.groupId,
            this.userId,
            state,
            payload
          );
        } else if (index === (currentTab2Idx + 1)) {
          //칸반
          this.$refs.dashboardkanban.setProjectId(this.projectId, state);
        } else if (index === (currentTab2Idx + 2)) {
          //히스토리
          this.$refs.dashboardHistory.setGroupId(
            this.groupId,
            this.projectId,
            this.userId,
            this.parentCategoryMid,
            this.projectName,
            state
          );
        } else if (index === (currentTab2Idx + 3)) {
          //일정
          const modalInfo = {
            title: "캘린더",
            width: "88%",
            height: "88%",
            obj: this.$modal,
            component: MAS_Cal,
            projectId: this.projectId,
            paperId: 'ALL',
          };
          this.showModal(modalInfo);
          this.changeTab2(0);
        }
      } else {
        // this.currentTab3 = index;
        if (index === 0) {
          //전체
          this.$refs.projectFileList.setgroupId(
            this.groupId,
            this.projectName,
            state
          );
        } else if (index === 1) {
          //보드별
          this.$refs.boardFileList.setgroupId(this.groupId, state);
        }
      }
    },
    deleteCategoryAtFile(param) {
      param.item.category.delKbn = 1;

      let obj = this;
      let reqData = {
        url: "/api/copaper/category/saveCategory",
        method: "post",
        params: param.item.category,
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          obj.$refs.boardFileList.searchKeyword =
            obj.$refs.boardFileList.searchResult;
          obj.$refs.boardFileList.selectedCategoryMid = "";
          obj.$refs.boardFileList.selectedPaperTitle = "";
          obj.$refs.boardFileList.selectedPaperId = "";
          obj.$refs.boardFileList.getGroupCategoryPaperList();
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    closeOkrLinkPopup() {
      this.$refs.dashboardHeader.setProjectId(this.res);
    },
    closeOtherProjectBoardLink() {
      //this.initData();
      this.$refs.dashboardList.setprojectIdAndGroupId(
        this.projectId,
        this.groupId,
        this.userId
      );
    },
    folderLength(data, parentCategoryMid) {
      this.parentCategoryMid = parentCategoryMid;
      if (data == 0) {
        this.noData = true;
      }
      this.$nextTick(function () {
        this.$refs.dashboardHeader.folderLength(data);
      });
    },
    /* byte 체크 */
    displayBytes(byteLength, addCategoryName, _event) {
      let obj = this;
      addCategoryName = _event.target.value;
      obj.addCategoryName = addCategoryName;
      let checkBytes = obj.getByteLength(obj.addCategoryName);
      obj.checkBytes = checkBytes;
      obj.error = false;
      if (checkBytes > byteLength) {
        obj.error = true;
      }
      if (checkBytes > 0) {
        obj.errorCategoryName = false;
      }
    },
    getByteLength(str) {
      if (str == null || str.length == 0) {
        return 0;
      }
      var size = 0;
      for (var i = 0; i < str.length; i++) {
        size += this.charByteSize(str.charAt(i));
      }
      return size;
    },
    cutByteLength(s, len) {
      if (s == null || s.length == 0) {
        return 0;
      }
      var size = 0;
      var rIndex = s.length;
      for (var i = 0; i < s.length; i++) {
        size += this.charByteSize(s.charAt(i));
        if (size == len) {
          rIndex = i + 1;
          break;
        } else if (size > len) {
          rIndex = i;
          break;
        }
      }
      return s.substring(0, rIndex);
    },
    charByteSize(ch) {
      if (ch == null || ch.length == 0) {
        return 0;
      }
      var charCode = ch.charCodeAt(0);

      if (charCode <= 0x00007f) {
        return 1;
      } else if (charCode <= 0x0007ff) {
        return 2;
      } else if (charCode <= 0x00ffff) {
        return 2;
      } else {
        return 2;
      }
    },
    nodataAddCategory() {
      if (!this.loginUserIsInternalUser) {
        //외부 사용자 .
        return;
      }
      if (this.step1) {
        return;
      }

      if (this.userInfo == null) {
        this.toastInfo.message = this.$i18nUtil.trans("TB044");
        this.showToast(this.toastInfo);
        return;
      }

      if (this.error) {
        return;
      } else if (this.errorCategoryName) {
        return;
      } else if (this.addCategoryName.length == 0) {
        this.errorCategoryName = true;
        return;
      } else {
        this.step1 = true;
        this.step2 = false;
        let obj = this;
        let reqData = {};
        reqData.params = {
          categoryId: null,
          categoryName: this.addCategoryName,
          groupId: this.groupId,
          parentCategoryMid: this.parentCategoryMid, // this.eList.parentCategoryMid,
          projectId: this.projectId,
          regUserId: this.userId, // 로그인 아이디
          section: "IDEATION",
          sortNo: null,
          modDate: null,
          modUserId: null,
          delKbn: 0,
          delDate: null,
          delUserId: null,
        };
        // console.log(reqData.params);
        reqData.req = obj.req;
        reqData.url = "/api/copaper/category/saveCategory";
        reqData.method = "post";
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then((res) => {
            this.categoryInfo = res.result.saveCategory;
          })
          .catch(function (err) {
            console.log(err);
          });
      }
    },
    nodataAddboard() {
      //this.$emit("reset-viewStyle","none");
      let obj = this;
      let reqData = {};
      reqData.params = {};
      reqData.req = obj.req;
      reqData.url = "/api/copaper/paper/getGeneratedPaperId";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          let errorCode = res.errorCode;
          let addPaperId = res.result;
          const modalInfo = {
            title: obj.$i18nUtil.trans("title.RegistBoardModal.000","업무보드 추가"),
            name: "registBoard",
            method: "post",
            width: "800px",
            // height: "493px",
            obj: obj.$modal,
            paperId: addPaperId,
            categoryMid: obj.categoryInfo.categoryMid,
            groupId: obj.categoryInfo.groupId,
            projectId: obj.categoryInfo.projectId,
            projectName: obj.projectName,
            docGrade:
              String(obj.projectInfo.cogroup.publicYn) == "1"
                ? "NORMAL"
                : "RESTRICT",
            paperTitle: "",
            contentPath: "",
            parentCategoryMid: obj.parentCategoryMid,
            component: RegistBoardModal,
          };

          obj.showModal(modalInfo);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    focusTextBox() {
      if (this.userInfo == null) {
        this.toastInfo.message = this.$i18nUtil.trans("TB044");
        this.showToast(this.toastInfo);
        event.target.blur();
        return;
      }
    },
    goPrevPage() {
      // this.$router.push("/general/home");
      // this.$router.push("/general/project");
      // 호출|알림 팝업 띄우기위한 값.
      this.setEventBackYn(true);

      let returnUrls = localStorage.getItem("returnUrls");
      if(returnUrls != null) {
        let urlList = returnUrls.split(",");
        if (urlList.length > 0) {
          if (urlList.length == 1) {
            localStorage.removeItem("returnUrls");
            // this.$router.push("/general/home");
          } else {
            urlList.pop();
            localStorage.setItem("returnUrls", urlList);
            // this.$router.replace(urlList[urlList.length-1]);
          }
        } else {
          this.$router.push("/general/home");
        }
      }else{
        this.$router.push("/general/home");
      }
      // history.back();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/general/project/detail/Dashboard.vue